// client/src/services/metaFeatures.js
// Which gated Meta (Instagram/Facebook) features are unlocked for this tenant,
// plus the Instagram Content Publishing Limit. Both are cheap reads used to
// drive "Pending Meta approval" UI and the publishing-limit indicator.

const cache = new Map(); // tenantId -> { caps, at }
const TTL_MS = 5 * 60 * 1000;

export async function getMetaCapabilities(tenantId) {
  if (!tenantId) return {};
  const hit = cache.get(String(tenantId));
  if (hit && Date.now() - hit.at < TTL_MS) return hit.caps;
  try {
    const res = await fetch(
      `/api/integrations/meta/capabilities?tenantId=${encodeURIComponent(tenantId)}`,
      { credentials: 'include' }
    );
    const data = await res.json().catch(() => ({}));
    const caps = (data && data.success && data.capabilities) ? data.capabilities : {};
    cache.set(String(tenantId), { caps, at: Date.now() });
    return caps;
  } catch {
    return {};
  }
}

// { usage, total, atLimit } or null when it can't be read (no IG connected etc).
export async function getInstagramPublishingLimit(tenantId) {
  if (!tenantId) return null;
  try {
    const res = await fetch(
      `/api/integrations/instagram/publishing-limit?tenantId=${encodeURIComponent(tenantId)}`,
      { credentials: 'include' }
    );
    const data = await res.json().catch(() => ({}));
    return (data && data.success && data.usage) ? data.usage : null;
  } catch {
    return null;
  }
}
